<template>
  <main class="notFound">
    <h1>404</h1>
    <p>ページが見つかりませんでした。</p>
    <p>Page non trouvée.</p>
    <router-link to="/">Home</router-link>
  </main>
</template>

<script>
export default {
  name: "NotFound",
};
</script>

<style scoped>
.notFound {
  text-align: center;
  padding: 80px 20px;
}
</style>